/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

export const browserLocale = navigator.language.split('-')[0].toLocaleUpperCase();
export const browserLanguage = `${navigator.language.split('-')[0]}_browser`.toUpperCase();
export const languagesSupported = [
    { code: browserLanguage, textKey: 'BROWSER_LANGUAGE' },
    { code: 'AR', textKey: 'ARABIC' },
    { code: 'BG', textKey: 'BULGARIAN' },
    { code: 'CS', textKey: 'CZECH' },
    { code: 'DA', textKey: 'DANISH' },
    { code: 'DE', textKey: 'GERMAN' },
    { code: 'EL', textKey: 'GREEK' },
    { code: 'EN', textKey: 'ENGLISH' },
    { code: 'ES', textKey: 'SPANISH' },
    { code: 'FI', textKey: 'FINNISH' },
    { code: 'FR', textKey: 'FRENCH' },
    { code: 'HE', textKey: 'HEBREW' },
    { code: 'HR', textKey: 'CROATIAN' },
    { code: 'HU', textKey: 'HUNGARIAN' },
    { code: 'IT', textKey: 'ITALIAN' },
    { code: 'JA', textKey: 'JAPANESE' },
    { code: 'KK', textKey: 'KAZAKH' },
    { code: 'KO', textKey: 'KOREAN' },
    { code: 'MS', textKey: 'MALAY' },
    { code: 'NL', textKey: 'DUTCH' },
    { code: 'NO', textKey: 'NORWEGIAN' },
    { code: 'PL', textKey: 'POLISH' },
    { code: 'PT', textKey: 'PORTUGUESE' },
    { code: 'RO', textKey: 'ROMANIAN' },
    { code: 'RU', textKey: 'RUSSIAN' },
    { code: 'SH', textKey: 'SERBIAN' },
    { code: 'SK', textKey: 'SLOVAK' },
    { code: 'SL', textKey: 'SLOVENIAN' },
    { code: 'SV', textKey: 'SWEDISH' },
    { code: 'TH', textKey: 'THAI' },
    { code: 'TR', textKey: 'TURKISH' },
    { code: 'UK', textKey: 'UKRAINIAN' },
    { code: 'ZH_CN', textKey: 'CHINESE_SIMPLIFIED' },
    { code: 'ZH_TW', textKey: 'TRADITIONAL_CHINESE' },
];

export const languageMap: { [key: string]: string } = {
    '3q': 'en_US_saprigi',
    '2q': 'en_US_sappsd',
    en: 'fallback',
    zh_cn: 'zh_CN',
    zh_tw: 'zh_TW',
};

export const IASLanguageMap: { [key: string]: string } = {
    ZH_CN: 'ZH',
    ZH_TW: 'zh_TW',
};

export const Product42kSKUIdList: number[] = [1];

export const AribaMapName: { [key: number]: string } = {
    8007885: 'Contracts',
    8000625: 'Contracts',
    8000641: 'Sourcing',
    8015622: 'Sourcing Base',
    8007883: 'Sourcing',
    8014432: 'Risk',
    8007890: 'Risk',
    8007889: 'SLP',
    8007892: 'B&I',
    8005800: 'B&I',
    8018731: 'Procurement Suite',
    8007927: 'Cloud TDD',
    8011396: 'Cloud TDD',
    8011078: 'Source-to-Contract',
    8007886: 'Procurement Suite',
    8018741: 'Procurement Suite',
};

export const FEATURE_FLAG = {
    DH_QUALTRICS_FEEDBACK_ROLLOUT: 'dh_qualtrics_feedback_rollout',
    DH_JOULE_ROLLOUT: 'dh_joule_rollout',
    DH_CLEAN_UP_BUTTON_ROLLOUT: 'dh_clean_up_button_rollout',
};
